module.exports = __webpack_public_path__ + "static/media/2H.a463cd85.svg";